import React, { FC } from 'react';
import styled from 'styled-components';

import { RatingSummary } from '../../../types/app';
import { isiOS } from 'config';

import greyStar from '../../../icons/grey-star-v2.svg';

interface OneStarRatingProps {
  rating: RatingSummary;
}

const Star = styled.div`
  background: url(${greyStar}) center center / contain no-repeat;
  width: 1em;
  height: 1em;
  padding-top: ${isiOS ? '3px' : '0'};
`;

const RatingText = styled.div`
  color: #707C83;
  padding-left: 10px;
`;

export const OneStarRating: FC<OneStarRatingProps> = ({ rating }) => {
  if (!rating || !rating.averageStars) {
    return <span/>
  }

  return (
    <React.Fragment>
      <Star />
      <RatingText
        id="rating-average-text"
        aria-label="rating-average-text"
      >{ rating.averageStars.toFixed(1)}</RatingText>
    </React.Fragment>
  );
}
